import { useCallback, useEffect, useState } from "react";
import { FormTemplate } from "../../FormTemplate/FormTemplate";
import apiMethods from "../../../../api/apiMethods";
import { patterns, validationErrorMessages } from "../../../../constants";
import { useForm } from "react-hook-form";
import { SuccessPopup } from "../../../SuccessPopup/SuccessPopup";
import { Icon } from "../../../SVGsprite/svgsprite";

const getSalePointsOptions = data => {
	return data.map(item => ({ name: item.name, value: item.id }));
};

const parsePhone = value => {
	if (isNaN(value) || value === " " || value === "") {
		return "";
	}
	return parseInt(value);
};

const PHONE_LENGTH = 10;
const title = "Добавление Продавца";

export function AddSellerForm() {
	const [loading, setLoading] = useState(false);
	const [errorsList, setErrorsList] = useState([]);
	const [salePointOptions, setSailPointOptions] = useState([]);
	const {
		register,
		handleSubmit,
		setValue,
		setError,
		formState: { errors },
		watch,
		reset,
	} = useForm();
	const [successMessage, setSuccessMessage] = useState(null);
	const [isTooltipVisible, setTooltipVisible] = useState(false);
	const [emailError, setEmailError] = useState("");

	const fetchSalingPoints = useCallback(async () => {
		setLoading(true);
		try {
			const { data } = await apiMethods.owner.getSalePoints();
			setSailPointOptions(getSalePointsOptions(data.data));
			setLoading(false);
		} catch ({ response }) {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		document.title = `${title} | Программа лояльности SK ZIC`;
	}, []);

	useEffect(() => {
		fetchSalingPoints();
	}, [fetchSalingPoints]);

	const toggleTooltip = () => {
		setTooltipVisible(!isTooltipVisible);
	};

	const closeTooltip = () => {
		setTooltipVisible(false);
	};

	const fetchFormData = useCallback(
		async body => {
			try {
				const { data } = await apiMethods.owner.postSeller(body);
				setSuccessMessage(data.message);

				// Очищаем форму и ошибки после успешной отправки
				reset({
					name: "",
					surname: "",
					email: "",
					phone: "",
					sale_point: "",
				});
				setErrorsList([]); // Очищаем список ошибок
				setEmailError(""); // Очищаем ошибку email
			} catch ({ response }) {
				if (response.data.message) {
					setErrorsList([response.data.message]);
				} else if (Array.isArray(response.data.message)) {
					setErrorsList(response.data.message);
				}

				if (response.status === 422) {
					Object.entries(response.data.errors).forEach(([key, val]) => {
						setError(key, { type: "custom", message: val[0] });
					});
				}
			}
		},
		[setError, reset],
	);

	const submit = data => {
		// Проверяем email на .ru
		if (
			data.email &&
			!data.email.endsWith(".ru") &&
			!data.email.endsWith("@sportavto.com") &&
			!data.email.endsWith("@essmo.org") &&
			!data.email.endsWith("@makk.club") &&
			!data.email.endsWith("@zamena.org")
		) {
			setEmailError(
				"На портале можно зарегистрироваться только с почтой в зоне .ru",
			);
			return; // Не отправляем форму
		}

		setEmailError(""); // Очищаем ошибку
		fetchFormData(data);
	};

	// Следим за изменением email для очистки ошибки
	const emailValue = watch("email");
	useEffect(() => {
		if (emailValue && emailValue.endsWith(".ru")) {
			setEmailError("");
		}
		if (emailValue === "") {
			setEmailError("");
		}
	}, [emailValue]);

	return (
		<FormTemplate title={title} isLoading={loading}>
			{
				<>
					<form onSubmit={handleSubmit(submit)} noValidate>
						{errorsList.map((item, index) => (
							<div className="errorMessage" key={index}>
								{item}
							</div>
						))}

						<div className="formRow">
							<label htmlFor="name">Имя</label>
							<input
								id="name"
								type="text"
								name="name"
								{...register("name", {
									required: validationErrorMessages.REQUIRED,
								})}
							/>
							{Boolean(errors.name?.message) && (
								<div className={"errorMessage"}>{errors.name.message}</div>
							)}
						</div>

						<div className="formRow">
							<label htmlFor="surname">Фамилия</label>
							<input
								id="surname"
								type="text"
								name="surname"
								{...register("surname", {
									required: validationErrorMessages.REQUIRED,
								})}
							/>
							{Boolean(errors.surname?.message) && (
								<div className={"errorMessage"}>{errors.surname.message}</div>
							)}
						</div>

						<div className="formRow">
							<label htmlFor="email" className="email_form_warning">
								E-mail
								<div className="tooltip_custom_warning" onClick={toggleTooltip}>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										style={{ cursor: "pointer" }}
									>
										<rect width="20" height="20" rx="10" fill="#B83436" />
										<path
											d="M10.7578 4.125L10.6562 12.2891H9.35156L9.24219 4.125H10.7578ZM9.19531 14.7734C9.19531 14.5391 9.26562 14.3411 9.40625 14.1797C9.55208 14.0182 9.76562 13.9375 10.0469 13.9375C10.3229 13.9375 10.5339 14.0182 10.6797 14.1797C10.8307 14.3411 10.9062 14.5391 10.9062 14.7734C10.9062 14.9974 10.8307 15.1901 10.6797 15.3516C10.5339 15.513 10.3229 15.5938 10.0469 15.5938C9.76562 15.5938 9.55208 15.513 9.40625 15.3516C9.26562 15.1901 9.19531 14.9974 9.19531 14.7734Z"
											fill="white"
										/>
									</svg>
									{isTooltipVisible && (
										<div className="tooltip_custom_warning--message">
											<p>
												Регистрация на сайте доступна только для почтовых
												адресов на российских доменах (@mail.ru, @yandex.ru,
												@bk.ru, @inbox.ru и др.)
											</p>
											<button
												type="button"
												className="modalClose"
												style={{ marginLeft: "auto" }}
												onClick={closeTooltip}
											>
												<Icon name="icon-close" sizeW="20" sizeH="20" />
												<span className="visuallyHidden">Закрыть</span>
											</button>
										</div>
									)}
								</div>
							</label>
							<input
								id="email"
								type="email"
								name="email"
								{...register("email", {
									required: validationErrorMessages.REQUIRED,
									pattern: {
										value: patterns.EMAIL,
										message: validationErrorMessages.INVALID_INPUT,
									},
								})}
							/>
							{Boolean(errors.email?.message) && (
								<div className={"errorMessage"}>{errors.email.message}</div>
							)}
							{/* Ошибка проверки .ru */}
							{emailError && (
								<div className="errorMessage" style={{ color: "#B83436" }}>
									{emailError}
								</div>
							)}
						</div>

						<div className="formRow">
							<label htmlFor="phone">Телефон</label>
							<div className="inputWrapper telWrapper">
								<input
									className={"phone"}
									id="phone"
									type="tel"
									pattern={"[0-9]{10}"}
									minLength={10}
									maxLength={10}
									name="phone"
									{...register("phone", {
										required: validationErrorMessages.REQUIRED,
										pattern: {
											value: patterns.PHONE,
											message: validationErrorMessages.INVALID_INPUT,
										},
										minLength: {
											value: 10,
											message: `${validationErrorMessages.MIN_LENGTH}${PHONE_LENGTH}`,
										},
										maxLength: {
											value: 10,
											message: `${validationErrorMessages.MAX_LENGTH}${PHONE_LENGTH}`,
										},
										onChange: event =>
											setValue("phone", parsePhone(event.target.value)),
									})}
								/>
							</div>
							<span className={"note"}>Формат: 10 цифр</span>
							{Boolean(errors.phone?.message) && (
								<div className={"errorMessage"}>{errors.phone.message}</div>
							)}
						</div>

						<div className="formRow">
							<label htmlFor="sale_point">Торговая точка</label>
							<select
								className="select"
								id="sale_point"
								type="text"
								name="sale_point"
								{...register("sale_point", {
									required: validationErrorMessages.REQUIRED,
								})}
							>
								<option value="">Выберите торговую точку</option>
								{salePointOptions?.length > 0 &&
									salePointOptions.map(option => (
										<option key={option.value} value={option.value}>
											{option.name}
										</option>
									))}
							</select>
							{Boolean(errors.sale_point?.message) && (
								<div className={"errorMessage"}>
									{errors.sale_point.message}
								</div>
							)}
						</div>

						<div className="formRow">
							<button type={"submit"} className={"btn btnPrimary"}>
								Зарегистрировать
							</button>
						</div>
					</form>
					<SuccessPopup
						isOpen={Boolean(successMessage)}
						onClose={() => {
							setSuccessMessage("");
						}}
						title={"Продавец успешно добавлен"}
						text={successMessage}
					/>
				</>
			}
		</FormTemplate>
	);
}
